<button type="button"
        class="btn btn-mobile-full"
        [class]="buttonStyle"
        (click)="handleClick()">
    {{label}}
</button>
